export default __webpack_public_path__ + "static/media/oscer-exit-case.b55bf0e4.svg";